<ng-container *ngIf="opened; else closed">

    <!-- Header -->
    <div data-test-id="drawerHeaderContainer" class="drawer__header">
        <!-- Title -->
        <div data-test-id="title" class="drawer__title">
            <ng-content select="[title]"></ng-content>
        </div>
        <!-- Close button -->
        <button data-test-id="closeActionButton" mat-icon-button [matTooltip]="CLOSE_LOCALIZED" (click)="close()" tabindex="-1">
            <mat-icon>clear</mat-icon>
        </button>
    </div>

    <!-- Contents -->
    <div data-test-id="drawerContentContainer" class="drawer__content">
        <ng-content></ng-content>
    </div>

    <!-- Actions -->
    <div data-test-id="drawerActionsContainer" class="drawer__actions">
        <div class="drawer__actions-inner">
            <ng-content select="[uiDrawerActions]"></ng-content>
        </div>
    </div>

</ng-container>

<ng-template #closed />
